/* istanbul ignore file: our visual regression tests are enough to test this simple switch-case statement */

const SOFT_HYPHEN = '\u00AD';

/**
 * Check out https://developer.mozilla.org/en-US/docs/Web/CSS/hyphens#suggesting_line_break_opportunities
 * to understand the purpose of this function.
 */
export function addLineBreakOpportunity(name: string) {
  switch (name) {
    case 'Computer, Unterhaltungselektronik & Zubehör':
      return `Computer, Unterhaltungs${SOFT_HYPHEN}elektronik & Zubehör`;

    default:
      return name;
  }
}
